import AudioPlayer from "@/components/AudioPlayer";
void AudioPlayer;

// Extracts a YouTube video id from common URL forms.
export function ytId(url = "") {
  const m = String(url).match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|live\/|shorts\/))([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : "";
}

// Renders a curated audio: YouTube embed (with optional loop) or an uploaded recitation.
export default function AudioMedia({ audio, label }) {
  if (!audio || !audio.url) return null;
  const title = label || audio.title || "Audio";
  if (audio.kind === "youtube") {
    const id = ytId(audio.url);
    if (!id) return null;
    const src = `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1${audio.loop ? `&loop=1&playlist=${id}` : ""}`;
    return (
      <div data-testid="audio-media-youtube" className="overflow-hidden border border-line bg-black">
        <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
          <iframe title={title} src={src} className="absolute inset-0 h-full w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen loading="lazy" />
        </div>
      </div>
    );
  }
  // Uploaded / direct audio file — loop when flagged.
  return (
    <div data-testid="audio-media-file" className="bg-[var(--saffron-dark)] px-5 py-4">
      <p className="mb-2 truncate text-sm text-[#f7f3ec]">{title}</p>
      <audio src={audio.url} controls loop={!!audio.loop} preload="metadata" className="w-full" />
    </div>
  );
}
